import { render, staticRenderFns } from "./QuickHelp.vue?vue&type=template&id=2119f961&functional=true&"
import script from "./QuickHelp.vue?vue&type=script&lang=js&"
export * from "./QuickHelp.vue?vue&type=script&lang=js&"
import style0 from "./QuickHelp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports